export const LTE_USAGE_BYTES = {
  TCP_CONNECT: {
    label: 'TCP 연결',
    payload: 0,
    mqtt: 0,
    tcp: 96,
  },
  MQTT_CONNECT: {
    label: 'MQTT 연결',
    payload: 0,
    mqtt: 64,
    tcp: 128,
  },
  MQTT_HEARTBEAT: {
    label: 'MQTT Heartbeat',
    payload: 0,
    mqtt: 4,
    tcp: 64,
  },
  PUBLISH_CUSTOM: {
    label: 'PUBLISH (커스텀)',
    payload: 130,
    mqtt: 15,
    tcp: 64,
  },
  PUBLISH_MFM: {
    label: 'PUBLISH (MFM)',
    payload: 15,
    mqtt: 80,
    tcp: 64,
  },
  PUBLISH_MFM_ARRAY: {
    label: 'PUBLISH (MFM 배열)',
    payload: 8,
    mqtt: 80,
    tcp: 64,
  },
  PUBLISH_ALARM: {
    label: 'PUBLISH (알람)',
    payload: 160,
    mqtt: 15,
    tcp: 64,
  },
} as const;

export const SECONDS = {
  MINUTE: 60,
  HOUR: 60 * 60,
  DAY: 60 * 60 * 24,
  MONTH: 60 * 60 * 24 * 30, // 30일로 계산
} as const;
